import classNames from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { CalendarEmptyIcon } from "../../AscIcons";
import {
  FirstPlaceBadge,
  SecondPlaceBadge,
  ThirdPlaceBadge,
} from "../../AscIllustrations";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscCompetitionCard.module.scss";
dayjs.extend(relativeTime);

export interface AscCompetitionCardProps {
  title: string;
  coverImageUrl?: string;
  date: string;
  rank: number;
  className?: string;
  loading?: boolean;
}

export default function AscCompetitionCard({
  title,
  coverImageUrl,
  date,
  rank = 1,
  className,
  loading = false,
}: AscCompetitionCardProps) {
  function getRank(rank: number) {
    switch (rank) {
      case 1:
        return (
          <>
            <FirstPlaceBadge />
            <span className={styles.label}>1st Place</span>
          </>
        );
      case 2:
        return (
          <>
            <SecondPlaceBadge />
            <span className={styles.label}>2nd Place</span>
          </>
        );
      case 3:
        return (
          <>
            <ThirdPlaceBadge />
            <span className={styles.label}>3rd Place</span>
          </>
        );
      default:
        return (
          <>
            <span className={styles.rank}>{rank}.</span>
            <span className={styles.label}>{rank}th Place</span>
          </>
        );
    }
  }
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      title={title}
      coverImageUrl={coverImageUrl}
      loading={loading}
      footer={
        <div className={styles.dateContent}>
          <CalendarEmptyIcon className={styles.calendarIcon} />
          <span className={styles.time}>
            {dayjs(date).format("D MMMM YYYY")}
          </span>
        </div>
      }
    >
      <div className={styles.rankContent}>{getRank(rank)}</div>
    </AscGenericCard>
  );
}
